<div class="row">
    <div class="col-5"></div>
    <div class="col-1 goldbar d-flex justify-content-center">
        ___________
    </div>
</div>